import TechnicianRow from './index';
const meta = {
    title: 'Features/IIMReview/TechnicianRow',
    component: TechnicianRow,
    parameters: {
        layout: 'padded'
    },
    args: {
        technicianAssessment: {
            id: 101,
            inspectionId: 1,
            technicianId: 42,
            technicianName: 'Jane Smith',
            rating: 'needs_review',
            score: 62,
            summary: null,
            descriptionMd: null,
            status: 'detected',
            completedAt: null,
            generatedAt: '2026-09-18T10:00:00Z'
        }
    }
};
export default meta;
export const NeedsReview = {};
export const NeedsCoaching = {
    args: {
        technicianAssessment: {
            id: 102,
            inspectionId: 1,
            technicianId: 43,
            technicianName: 'Bob Johnson',
            rating: 'needs_coaching',
            score: 38,
            summary: null,
            descriptionMd: null,
            status: 'detected',
            completedAt: null,
            generatedAt: '2026-09-18T10:00:00Z'
        }
    }
};
